var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { BadgeCellStructure } from '../components/BadgeCellStructure';
// Utils
import styled from 'styled-components';
export var StyledBadgeCell = styled(BadgeCellStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: table-cell;\n  height: 48px;\n  padding: 8px 4px;\n  vertical-align: middle;\n  box-sizing: border-box;\n"], ["\n  display: table-cell;\n  height: 48px;\n  padding: 8px 4px;\n  vertical-align: middle;\n  box-sizing: border-box;\n"])));
var templateObject_1;
//# sourceMappingURL=StyledBadgeCell.js.map